import React, { useState, useCallback } from "react"
import { useWindowSizes } from "@hooks/window"
import Gallery from "react-photo-gallery"
import Carousel, { ModalGateway, Modal } from "react-images"

const GoogleGallery = ({ data, index }) => {
  console.log("[GoogleGallery.js] data", data)

  const photos = data.fields.map((item, index) => {
    return {
      id: `g_img_${index}`,
      key: `g_img_${index}`,
      src: item.image.url,
      width: item.image.dimensions.width,
      height: item.image.dimensions.height,
      alt: item.image.alt,
    }
  })

  const [currentImage, setCurrentImage] = useState(0)
  const [viewerIsOpen, setViewerIsOpen] = useState(false)

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index)
    setViewerIsOpen(true)
  }, [])

  const closeLightbox = () => {
    setCurrentImage(0)
    setViewerIsOpen(false)
  }
  const { isIphonePlus } = useWindowSizes()

  const colNumber = isIphonePlus ? 2 : 3

  return (
    <section className="google_gallery">
      <div className="row">
        <div className="col col12">
          <Gallery
            photos={photos}
            // targetRowHeight={200}
            columns={colNumber}
            direction="column"
            margin={8}
            onClick={openLightbox}
          />
          <ModalGateway>
            {viewerIsOpen ? (
              <Modal onClose={closeLightbox}>
                <Carousel
                  currentIndex={currentImage}
                  views={photos.map(x => ({
                    ...x,
                    srcset: x.srcSet,
                    caption: x.title,
                  }))}
                />
              </Modal>
            ) : null}
          </ModalGateway>
        </div>
      </div>
    </section>
  )
}

export default GoogleGallery
